import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowUpIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path d="M8 11.2667V1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.1998 5.2L7.9998 1L3.7998 5.2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15 15H1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
